import React, { memo } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { BIDataExists } from 'data/constants';
import { useRegionalLink } from 'hooks/useRegionalLink';

import classes from './CustomerInfoLinks.module.scss';
import { access, hasAccess, resources } from 'utils/permissions';

const CustomerInfoLinks = ({ url, hasChilds, hasArr }) => {
  const { t } = useTranslation(['activity']);
  const generateRegionalPath = useRegionalLink();

  return (
    <nav className={classes.sublinks}>
      {!url.includes('/marketing/leads/') && (
        <>
          {hasAccess([resources.CUSTOMERS, access.READ]) && (
            <NavLink
              className={classes.sublinks_item}
              activeClassName={classes.sublinks_item__active}
              to={generateRegionalPath(`${url}/general`)}
            >
              {t('activity:customers:GENERAL')}
            </NavLink>
          )}

          {hasAccess([resources.CUSTOMERS, access.READ]) && (
            <NavLink
              className={classes.sublinks_item}
              activeClassName={classes.sublinks_item__active}
              to={generateRegionalPath(`${url}/environment`)}
            >
              {t('activity:customers:ENVIRONMENT')}
            </NavLink>
          )}

          {hasAccess([resources.TENANT_SENSITIVE_DATA, access.READ]) && (
            <NavLink
              className={classes.sublinks_item}
              activeClassName={classes.sublinks_item__active}
              to={generateRegionalPath(`${url}/platform`)}
            >
              {t('activity:customers:PLATFORM')}
            </NavLink>
          )}

          {hasAccess([resources.TENANT_LICENSING_DATA, access.READ]) && (
            <NavLink
              className={classes.sublinks_item}
              activeClassName={classes.sublinks_item__active}
              to={generateRegionalPath(`${url}/licensing`)}
            >
              {t('activity:customers:LICENSING')}
            </NavLink>
          )}

          {hasAccess([resources.TENANT_SENSITIVE_DATA, access.READ]) && (
            <NavLink
              className={classes.sublinks_item}
              activeClassName={classes.sublinks_item__active}
              to={generateRegionalPath(`${url}/billing`)}
            >
              {t('activity:customers:BILLING')}
            </NavLink>
          )}
        </>
      )}

      {hasAccess([resources.CUSTOMERS, access.READ]) && hasChilds && (
        <NavLink
          className={classes.sublinks_item}
          activeClassName={classes.sublinks_item__active}
          to={generateRegionalPath(`${url}/children`)}
        >
          {t('activity:customers:CHILDREN')}
        </NavLink>
      )}

      {hasAccess([resources.TENANT_SENSITIVE_DATA, access.READ]) &&
        hasArr &&
        BIDataExists && (
          <NavLink
            className={classes.sublinks_item}
            activeClassName={classes.sublinks_item__active}
            to={generateRegionalPath(`${url}/customer-arr-activity`)}
          >
            {t('activity:arrActivity:ARR_ACTIVITY')}
          </NavLink>
        )}

      {hasAccess([resources.TENANT_SENSITIVE_DATA, access.READ]) &&
        BIDataExists && (
          <NavLink
            className={classes.sublinks_item}
            activeClassName={classes.sublinks_item__active}
            to={generateRegionalPath(`${url}/satisfaction`)}
          >
            {t('activity:customers:SATISFACTION')}
          </NavLink>
        )}
    </nav>
  );
};

CustomerInfoLinks.propTypes = {
  url: PropTypes.string,
  hasChilds: PropTypes.bool,
  hasArr: PropTypes.bool
};

export default memo(CustomerInfoLinks);
